// assets
import {
    IconPlug,
    Icon24Hours,
    IconClockRecord,
    IconAntenna,
    IconChartHistogram,
    IconUsers,
    IconStatusChange,
    IconHeartRateMonitor,
    IconUsersGroup,
    IconAccessible
} from '@tabler/icons-react';

// constant
const icons = {
    IconPlug,
    Icon24Hours,
    IconClockRecord,
    IconAntenna,
    IconChartHistogram,
    IconUsers,
    IconStatusChange,
    IconHeartRateMonitor,
    IconUsersGroup,
    IconAccessible
};

// ==============================|| REALTIME MENU ITEMS ||============================== //

const parentClientSettings = {
    id: 'setting',
    title: 'Settings  [ ADMIN ONLY ]',
    type: 'group',
    children: [
        {
            id: 'setting-general',
            title: 'General',
            type: 'collapse',
            icon: icons.IconStatusChange,
            children: [
                {
                    id: 'general-default',
                    title: 'Default',
                    type: 'item',
                    url: '/settings/default/defaultSetting',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'setting-customers',
            title: 'Customers',
            type: 'item',
            url: '/settings/customerManagement/customers',
            icon: icons.IconUsersGroup,
            breadcrumbs: false
        },
        {
            id: 'setting-scadaScreens',
            title: 'Screens',
            type: 'item',
            url: '/settings/scada/screenconfig',
            icon: icons.IconHeartRateMonitor,
            breadcrumbs: false
        },
        // {
        //     id: 'setting-user',
        //     title: 'Users',
        //     type: 'item',
        //     url: '/settings/userManagement/users',
        //     icon: icons.IconUsers,
        //     breadcrumbs: false
        // }
        {
            id: 'setting-access-control',
            title: 'Access Control',
            type: 'collapse',
            icon: icons.IconAccessible,
            children: [
                {
                    id: 'setting-user',
                    title: 'Users',
                    type: 'item',
                    url: '/settings/userManagement/users',
                    breadcrumbs: false
                },
                {
                    id: 'setting-access-control-permission-levels',
                    title: 'Permission Levels',
                    type: 'item',
                    url: '/settings/userManagement/permissionLevels',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default parentClientSettings;
